export const SUGGESTED_FAQ_DEFAULT_SORT = 'createdAt';
